import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const plans = createSlice({
  name,
  initialState: {
    plans: []
  },
  reducers: {
    setPlans: (state, { payload }) => {
      state.plans = payload
    },
    resetPlans: (state) => {
      state.plans = []
    }
  }
})

export const { resetPlans, setPlans } = plans.actions

export default plans.reducer
